import { Form } from 'antd'

import PageWrap from '../../components/layout/PageWrap'
import FormWrap from '../../components/forms/FormWrap'
import FormBlock from '../../components/forms/FormBlock'
import CommunityIconEditor from '../../components/forms/CommunityIconEditor'

import {
    CommunityDescription,
    cleanBeforeSending,
    DEFAULT_ICON_STYLE,
    DEFAULT_ICON_HEAD_STYLE,
    DEFAULT_ICON_HFIVE_STYLE,
    DEFAULT_TEXT_GRADIENT,
    DEFAULT_BG_HFIVE,
} from '../../constants/forms/Communities'
import { createCommunity as request } from '../../network/API'

const CreateCommunity = () => {
    const [form] = Form.useForm()

    return (
        <PageWrap goBack title="COMMUNITIES_CREATE">
            <FormWrap
                title="create_community"
                form={form}
                request={request}
                onSuccess="/communities"
                onCancel="/communities"
                cleanBeforeSending={cleanBeforeSending}
                invalidate={['getCommunities']}
                data={{
                    isCellar: false,
                    isPet: false,
                    status: 'publish',
                    zikoContactId: '',
                    bgHFive: DEFAULT_BG_HFIVE,
                    mpConfig: {
                        iconStyle: DEFAULT_ICON_STYLE,
                        iconHeadStyle: DEFAULT_ICON_HEAD_STYLE,
                        iconHFiveStyle: DEFAULT_ICON_HFIVE_STYLE,
                        textGradient: DEFAULT_TEXT_GRADIENT,
                    },
                }}
            >
                <div className="SectionVerticalWrap">
                    <FormBlock form={form} formTemplate={CommunityDescription} />
                    <CommunityIconEditor />
                </div>
            </FormWrap>
        </PageWrap>
    )
}

export default CreateCommunity
